module.exports = __webpack_public_path__ + "img/Jonathan Moser Resume 2019.c86af708.png";